<template>
  <div class="newdetail_wrap article-detail-page">
    <div class="red_top_bg article-top">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ data.title }}
      </div>
    </div>
    <div class="ctn article-content">
      <!-- <vue-editor v-model="data.content" style="display: none"/> -->
      <div
        class="contract_box article-body"
        v-html="data.content"
      />
      <time class="article-time">
        2019-03-21 02:50:35
      </time>
    </div>
  </div>
</template>

<script>

    import Fetch from "../../utils/fetch";
	import bsHeader from '../../components/bsHeader.vue'

    export default {
        name: "Aritcle",
        components: {bsHeader},
        data() {
            return {
                data: {},
            };
        },
        created() {
            this.$parent.footer('user',false);
        },
        mounted() {
            this.start();
        },
        methods: {
            start() {
                Fetch('/index/article_detail', {
                    id: this.$router.history.current.params.code
                }).then(res => {
                    this.data = res.data;
                })
            },
        }
    };
</script>

<style lang="less" scoped>
.article-detail-page {
    min-height: 100vh;
    overflow-x: hidden;
    overflow-y: auto;
    background: #fff;
    color: #000;
    box-sizing: border-box;
}

.article-top {
    position: fixed;
    top: 0;
    left: 50%;
    z-index: 10;
    height: 50px;
    background: #fff;
    border-bottom: 1px solid #e8e9ee;
    transform: translateX(-50%);
    box-sizing: border-box;

    .big_tit {
        max-width: 72%;
        height: 50px;
        top: 0;
        color: #000;
        font-size: 18px;
        font-weight: 700;
        line-height: 50px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        word-break: normal;
    }
}

.article-content {
    width: 100%;
    min-height: 100vh;
    margin: 50px auto 0;
    padding: 10px 8px 0;
    background: #fff;
    box-sizing: border-box;
}

.article-body {
    width: 100%;
    color: #6d7688;
    font-size: 14px;
    font-weight: 700;
    line-height: 27px;
    word-break: break-word;
    box-sizing: border-box;

    /deep/ * {
        max-width: 100%;
        font-size: inherit !important;
        line-height: inherit !important;
        color: inherit !important;
        background: transparent !important;
        box-sizing: border-box;
    }

    /deep/ p,
    /deep/ div {
        margin: 0;
    }

    /deep/ p + p,
    /deep/ div + div {
        margin-top: 12px;
    }

    /deep/ img {
        display: block;
        max-width: 100%;
        height: auto;
        margin: 10px auto;
    }
}

.article-time {
    display: block;
    margin: 48px 8px 0 0;
    color: #555d6b;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    text-align: right;
    word-break: break-word;
}

@media screen and (max-width: 374px) {
    .article-body {
        font-size: 19px;
        line-height: 26px;
    }

    .article-time {
        font-size: 15px;
        line-height: 21px;
    }
}
</style>
